import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit {
  modalCreate: boolean = false;
  accion = undefined;


  image = "assets/img/batman-icon.png";

  constructor(public userService: UsuarioService) { }

  ngOnInit(): void {
    let data = this.userService.getLocalStorage();
    if (data['user']) {
      this.image = data['user']['picture']
    }
  }
  activateModal() {
    this.modalCreate = true;
  }
  updateModalCreate(event) {

    if (event.type == "close") {
      this.modalCreate = false;
    }
    if (event.type == "finalized") {
      //this.allCharactares();
      //this.allCharactares();
      this.modalCreate = false;
      //llamar webservice de creacion de dialogos
    }
  }

  logout(){
    localStorage.clear();
    window.location.href = "/"
  }

}
